import React, { useEffect, useState } from 'react';
import BaseModal from '../baseModal';
import axios from 'axios';
import { Button, TextField, MenuItem, FormControl, InputLabel, Select, Avatar } from '@mui/material';
import { clientNetwork, userExtensionsFileName } from '../../lib/constants';

import { callReadOnlyFunction } from '@stacks/transactions';
import { authenticatedUserAddress, network } from '../../services/auth';
import { fetchData } from '../../services/stacks';
import { SentimentButton } from '../../services/chime/Sentiments';

const ExtensionModal = ({
    show, close, filters,
    extrasValues,
    setExtrasValues,
    extensionAction,
    setExtensionAction,
    setErrorMsg,
    setOpenSnackBar,
    setOpenConfirmModal,
    txId,
    setTx_Id,
    authorPrincipal,
    likeFtAmount,
    disLikeFtAmount
}) => {
    const [extensions, setExtensions] = useState([]);
    const [selectedExtension, setSelectedExtension] = useState('');
    const [args, setArgs] = useState([]);

    const authedUser = authenticatedUserAddress({ network: clientNetwork });

    function handleExtrasValueChanged(e, index) {
        const { name, value } = e.target;
        const theVal = (name === "int" || name === "uint") ? Number(value) : value;
        setExtrasValues(prevExtrasValues => ({
            ...prevExtrasValues,
            values: { [index]: { ...prevExtrasValues.values[index], [name]: theVal } },
            postconditions: { [index]: selectedExtension?.postconditions }
        }));
    }

    async function handleSelectExtension(e) {
        const { name, value } = e.target;
        console.log({ name, value });
        if (!value) {
            setArgs([]);
            return;
        }

        const { address, index } = value;
        const contractAddress = address.split('.')[0];
        const contractName = address.split('.')[1];
        try {
            // Fetch contract metadata
            const contractMeta = (await callReadOnlyFunction({
                contractAddress,
                contractName,
                functionName: 'get-ext-metadata',
                functionArgs: [],
                network: network({ network: clientNetwork }),
                senderAddress: authedUser
            }))?.value?.data;
            // Fetch description data from the metadata
            const metaData = (await axios.get(contractMeta?.description?.data))?.data;
            const usersArgs = metaData?.argsFromUser;
            const newArgs = Object.keys(usersArgs).map(key => {
                const fields = Object.keys(usersArgs[key])
                    .filter(k => !usersArgs[k]?.render)
                    .map(keys => {
                        console.log({ keys });
                        return { type: keys, label: usersArgs[key][keys]?.label, order: usersArgs[key][keys]?.order, optional: usersArgs[key][keys]?.optional };
                    })
                return fields;
            })

            // console.log({ metaData, newArgs, usersArgs, value: { ...value, postconditions: metaData?.postconditions } });
            setExtrasValues({
                values: {
                    [index]: {// Spread the current extrasValues at the index
                        stringutf8: (name === "stringutf8" && extrasValues[index][name]) ? extrasValues[index][name] : '',
                        stringascii: (name === "stringascii" && extrasValues[index][name]) ? extrasValues[index][name] : '',
                        uint: (name === "uint" && extrasValues[index][name]) ? extrasValues[index][name] : '',
                        int: (name === "int" && extrasValues[index][name]) ? extrasValues[index][name] : '',
                        principal: (name === "principal" && extrasValues[index][name]) ? extrasValues[index][name] : '',
                        bool: (name === "bool" && extrasValues[index][name]) ? extrasValues[index][name] : '',
                        buff: (name === "buff" && extrasValues[index][name]) ? extrasValues[index][name] : '',
                        proxy: (name === "proxy" && extrasValues[index][name]) ? extrasValues[index][name] : ''
                    }
                },
                postconditions: {},
                extensionAddress: address
            });
            setSelectedExtension({ ...value, postconditions: metaData?.postconditions });
            setArgs(newArgs);
        } catch (error) {
            console.log({ error });
        }

    }

    const handleDisregard = () => {
        setSelectedExtension('');
        setArgs([]);
        setExtensionAction();
        close();  // Close the modal
    };

    const handleSaveAndUse = () => {
        setExtensionAction('');
        close();
    }

    const filterExtensions = (extensions) => {
        const filteredExtensions = extensions.filter(ext => {
            if (ext?.ops) {
                const hasMatchingOps = Object.keys(ext.ops).some(key => {
                    return filters[key] === true && ext.ops[key] === true;
                });
                return hasMatchingOps;
            }
            return false;
        });
        return filteredExtensions;
    };

    useEffect(() => {
        async function handlePageInit() {
            let userExtensions = [];
            const res = await fetchData(userExtensionsFileName);
            console.log({ res });
            if (res?.success) {
                userExtensions = res.result; //should be this                
            }
            setExtensions(userExtensions);
        }
        handlePageInit();
    }, [])

    useEffect(() => {
        console.log({ extrasValues });
    }, [extrasValues])

    return (
        <BaseModal show={show} handleClose={handleDisregard}>
            <div className='extension'>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label" >Extensions</InputLabel>
                    <Select
                        labelId="extension-select-label"
                        label="Extensions"
                        id="extension-select"
                        value={selectedExtension}
                        onChange={handleSelectExtension}
                        renderValue={(info) => (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                <Avatar src={info?.image.value} /> {info?.name.value}
                            </div>
                        )}
                    >
                        <MenuItem value="" disabled>
                            <em>Extensions</em>
                        </MenuItem>
                        {filterExtensions(extensions).map((info, index) => (
                            <MenuItem value={{ ...info, index }} key={index}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                    <Avatar src={info?.image.value} /> {info?.name.value}
                                </div>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {args.map((arg, index) => (
                    <div key={index}>
                        {
                            arg.map((field, i) => (
                                <TextField
                                    key={i}
                                    fullWidth
                                    label={field.label}
                                    type={field.type === 'bool' ? 'checkbox' : (field.type === 'uint' || field.type === 'int') ? 'number' : 'text'}
                                    onChange={(e) => handleExtrasValueChanged(e, index)}
                                    name={field.type}
                                    value={extrasValues.values[index][field.type]}
                                    required={!field.optional}
                                    margin="normal"
                                />
                            ))
                        }
                    </div>
                ))}

                <div style={{ marginTop: 20 }}>
                    <Button onClick={handleSaveAndUse} id="ext-btn-save" style={{ marginRight: 10 }}>
                        {{ "like-message": true, "dislike-message": true }[extensionAction]
                            ? <SentimentButton
                                sentiment={{ "like-message": true, "dislike-message": false }[extensionAction]}
                                text={extensionAction}

                                setOpenConfirmModal={setOpenConfirmModal}
                                setOpenSnackBar={setOpenSnackBar}
                                setTx_Id={setTx_Id}
                                setErrorMsg={setErrorMsg}

                                txId={txId}

                                ftAmount={{ "like-message": likeFtAmount, "dislike-message": disLikeFtAmount }[extensionAction]}
                                authorPrincipal={authorPrincipal}

                                extras={extrasValues}
                            />
                            : 'Save and Use'}
                    </Button>
                    <Button onClick={handleDisregard} id="ext-btn-cancel">
                        Disregard
                    </Button>
                </div>
            </div>
        </BaseModal>
    );
};

export default ExtensionModal;